import { ChangeEvent, FC, useEffect } from 'react';
import { RadioChangeEvent, Row } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import {
    clearOnboardinBankAccount,
    clearOnboardingErrorsValidation,
    updateOnboardingBankAccount,
} from '../../../../redux/reducers/onboarding/sliceReducer';
import moment from '../../../../common/constants/moment';
import { commonYearDateFormat } from '../../../../common/constants/dateConstants';
import '../../../my-information-page/MyInformationPage.less';
import { OnboardingFileKeys } from '../../../../common/api/services/HistoryApi/common/OnboardingFileKeys';
import { ROUTER_PATHS } from '../../../../navigation/routerPaths';
import { historyApi } from '../../../../common/api/services/HistoryApi/historyApi';
import { useParams } from 'react-router-dom';
import { setActiveFields } from '../../../../redux/reducers/onboarding-history/sliceReducer';
import HistoryComponent from '../../history/HistoryComponent';
import { FieldKeys } from '../../../../common/api/services/HistoryApi/types/fieldKeys';
import { initialHistoryFields } from '../../constants/initialHistoryFields';

const BankAccountTab: FC = () => {
    const dispatch = useAppDispatch();

    const { consultantId } = useParams<{
        consultantId: string;
    }>();

    const errorMessages = useAppSelector((state) => state.onboarding.validationError.bankAccount);

    useEffect(() => {
        const matchedKey = OnboardingFileKeys.find((item) =>
            Object.keys(item).some((key) => key === ROUTER_PATHS.bankAccount)
        );
        if (matchedKey) {
            historyApi
                .getOnboardingActiveFields({
                    userId: consultantId || 'consultant',
                    keys: matchedKey[ROUTER_PATHS.bankAccount],
                })
                .then((resp) => dispatch(setActiveFields(resp.data)));
        }
    }, []);

    return (
        <div className="bank-account-v2">
            <div className="bank-account-title">
                <h4>Bank account</h4>
            </div>
            <HistoryComponent
                fieldKey={FieldKeys.bankAccount}
                tabName="Bank account"
                onChangeArray={[]}
                shownElements={initialHistoryFields[FieldKeys.bankAccount]}
                labels={[
                    { key: 'bankDetailsLabel', value: 'Bank details' },
                    { key: 'accountDetailsLabel', value: 'Account details' },
                ]}
                isHideTabName
            />
        </div>
    );
};

export default BankAccountTab;
